export const LOCATION_TO_LOCALE_MAP = {
  eur: new Map([
    ['en', process.env.VUE_APP_LOCATION_KEY_EUW],
    ['de', process.env.VUE_APP_LOCATION_KEY_EUW],
    ['at', process.env.VUE_APP_LOCATION_KEY_EUW],
    ['de', process.env.VUE_APP_LOCATION_KEY_EUW],
    ['ru', process.env.VUE_APP_LOCATION_KEY_RUS],
    ['it', process.env.VUE_APP_LOCATION_KEY_EUW],
    ['fr', process.env.VUE_APP_LOCATION_KEY_EUW],
    ['gb', process.env.VUE_APP_LOCATION_KEY_GBR],
    ['pl', process.env.VUE_APP_LOCATION_KEY_EUW],
    ['pt', process.env.VUE_APP_LOCATION_KEY_SPA],
    ['es', process.env.VUE_APP_LOCATION_KEY_SPA],
  ]),
  int: new Map([
    ['en', process.env.VUE_APP_LOCATION_KEY_USE],
    ['us/en', process.env.VUE_APP_LOCATION_KEY_USE],
    ['us/es', process.env.VUE_APP_LOCATION_KEY_USE],
    ['ca/en', process.env.VUE_APP_LOCATION_KEY_CAN],
    ['ca/fr', process.env.VUE_APP_LOCATION_KEY_CAN],
    ['mx', process.env.VUE_APP_LOCATION_KEY_USM],
    ['ar', process.env.VUE_APP_LOCATION_KEY_BRA],
    ['au', process.env.VUE_APP_LOCATION_KEY_AUS],
    ['nz', process.env.VUE_APP_LOCATION_KEY_AUS],
    ['ja', process.env.VUE_APP_LOCATION_KEY_JPN],
    ['br', process.env.VUE_APP_LOCATION_KEY_BRA],
  ]),
};
